import React from "react";
import "../../styles/containers/Contact.scss";

function Contact() {
  return (
    <div className="Contact">
      <h1 className="main-heading">Contact Machwerk</h1>
      <h3 className="description">
        Emergency Calls: +49 162 6665 444
        <br />
        Support: hello@dasmachwerk.com
      </h3>
    </div>
  );
}
export default Contact;
